import type { Viewport } from 'pixi-viewport';

export const WORLD_SIZE = 7500; // Збільшено в 2 рази (було 3750)

const INITIAL_ZOOM = 0.25; // Базовий початковий зум (може бути збільшений на великих екранах)
// Максимальне віддалення - динамічне, залежить від розміру екрану
// Світ завжди має бути більшим за екран щоб зум не стрибав на великих моніторах
const MIN_ZOOM_OUT_SCALE = 0.7 / 3; // ≈ 0.233 — мінімум для маленьких екранів
// Максимальне наближення (максимальний масштаб) - можна наблизитися в 2 рази більше ніж початково
const MAX_ZOOM_IN_SCALE = 12.0;

const getMinZoomScale = (screenWidth: number, screenHeight: number): number => {
  // Мінімальний масштаб = екран не може вмістити весь світ
  // Додаємо 20% запас щоб завжди була можливість скролити
  const scaleToFitWidth = screenWidth / WORLD_SIZE;
  const scaleToFitHeight = screenHeight / WORLD_SIZE;
  const scaleToFit = Math.max(scaleToFitWidth, scaleToFitHeight) * 1.2;
  return Math.max(MIN_ZOOM_OUT_SCALE, scaleToFit);
};

const applyClampZoom = (viewport: Viewport) => {
  const minScale = getMinZoomScale(viewport.screenWidth, viewport.screenHeight);
  viewport.clampZoom({
    minScale,
    maxScale: MAX_ZOOM_IN_SCALE,
  });
};

export { INITIAL_ZOOM, MIN_ZOOM_OUT_SCALE, MAX_ZOOM_IN_SCALE, getMinZoomScale, applyClampZoom };
